import React from "react";
import { PUBLIC_ROUTE } from "./route.constants";
import { PersonalLoan } from "@containers/PersonalLoan/containers/PersonalLoan";
import { Tracking } from "@containers/Tracking/tracking";
import { Verify } from "@containers/Verify/Verify";
import { Esign } from "@containers/Esign/Esign";
import { AcceptAutoFinance } from "@containers/AcceptAutoFinance/AcceptAutoFinance";
import { AcceptLiftLoan } from "@containers/AcceptLiftLoan/AcceptLiftLoan";
import { AcceptLineOfCredit } from "@containers/AcceptLineOfCredit/AcceptLineOfCredit";
import { BankStatements } from "@containers/BankStatements/BankStatements";
import { DeclineRouter } from "@containers/DeclineRouter/DeclineRouter";
import { ThankYou } from "@containers/ThankYou/components/ThankYou";
import { NotFound } from "@containers/404/404";
import { Decline } from "./containers/DeclineRouter/containers/Decline";
import { DeclineInProgress } from "./containers/DeclineRouter/containers/DeclineInProgress";
import { DeclineApplicationNotFound } from "./containers/DeclineRouter/containers/DeclineApplicationNotFound";
import { DeclineApplicationExpired } from "./containers/DeclineRouter/containers/DeclineApplicationExpired";
import { TRACKING_STATUS } from "./constants/commonConstants";
import { ApprovedEsign, Cancelled, Declined, Expired, Funded, InAssessment, InSchedule } from "./containers/Tracking/containers";

export const routeConfig = [
  {
    path: PUBLIC_ROUTE.LANDING,
    element: <PersonalLoan />
  },
  {
    path: PUBLIC_ROUTE.LANDING + PUBLIC_ROUTE.LIVING_SITUATION,
    element: <PersonalLoan />
  },
  {
    path: PUBLIC_ROUTE.LANDING + PUBLIC_ROUTE.LIVELIHOOD_INCOME,
    element: <PersonalLoan />
  },
  {
    path: PUBLIC_ROUTE.LANDING + PUBLIC_ROUTE.BANK_STATEMENT_PAGE,
    element: <PersonalLoan />
  },
  {
    path: PUBLIC_ROUTE.STATUS,
    element: <Tracking />
  },
  {
    path: PUBLIC_ROUTE.STATUS + TRACKING_STATUS.IN_SCHEDULE,
    element: <Tracking><InSchedule /></Tracking>
  },
  {
    path: PUBLIC_ROUTE.STATUS + TRACKING_STATUS.IN_ASSESSMENT,
    element: <Tracking><InAssessment /></Tracking>
  },
  {
    path: PUBLIC_ROUTE.STATUS + TRACKING_STATUS.DECLINED,
    element: <Tracking><Declined /></Tracking>
  },
  {
    path: PUBLIC_ROUTE.STATUS + TRACKING_STATUS.APPROVED_ESIGN,
    element: <Tracking><ApprovedEsign /></Tracking>
  },
  {
    path: PUBLIC_ROUTE.STATUS + TRACKING_STATUS.FUNDED,
    element: <Tracking><Funded /></Tracking>
  },
  {
    path: PUBLIC_ROUTE.STATUS + TRACKING_STATUS.EXPIRED,
    element: <Tracking><Expired /></Tracking>
  },
  {
    path: PUBLIC_ROUTE.STATUS + TRACKING_STATUS.CANCELLED,
    element: <Tracking><Cancelled /></Tracking>
  },
  {
    path: PUBLIC_ROUTE.VERIFY + "/*",
    element: <Verify />
  },
  {
    path: PUBLIC_ROUTE.ESIGN,
    element: <Esign />
  },
  {
    path: PUBLIC_ROUTE.ACCEPT_AUTO_FINANCE,
    element: <AcceptAutoFinance />
  },
  {
    path: PUBLIC_ROUTE.ACCEPT_LIFT_LOAN,
    element: <AcceptLiftLoan />
  },
  {
    path: PUBLIC_ROUTE.ACCEPT_LINE_OF_CREDIT,
    element: <AcceptLineOfCredit />
  },
  {
    path: PUBLIC_ROUTE.BANK_STATEMENT_PAGE,
    element: <BankStatements />
  },
  {
    path: PUBLIC_ROUTE.DECLINE,
    element: <DeclineRouter><Decline /></DeclineRouter>
  },
  {
    path: PUBLIC_ROUTE.DECLINE + '/in-progress',
    element: <DeclineRouter><DeclineInProgress /></DeclineRouter>
  },
  {
    path: PUBLIC_ROUTE.DECLINE + '/application-not-found',
    element: <DeclineRouter><DeclineApplicationNotFound /></DeclineRouter>
  },
  {
    path: PUBLIC_ROUTE.DECLINE + '/application-expired',
    element: <DeclineRouter><DeclineApplicationExpired /></DeclineRouter>
  },
  {
    path: PUBLIC_ROUTE.THANK_YOU,
    element: <ThankYou />
  },
  {
    path: PUBLIC_ROUTE.PAGE_NOT_FOUND,
    element: <NotFound />
  }
];